var ChannelTalk = function () {

    return {
        drawButton: drawButton,
        showButton: showButton,
        drawGptTrainer: drawGptTrainer,
    }

    function showButton(isShow) {
        if (Often.isFunc('HAPPY_TALK')) {
            if (!window.ht) return;
            if (isShow) {
                ht.open();
            } else {
                ht.close();
            }
            return;
        }

        if (Often.isFunc("CHANNEL_TALK")) {
            if (!window.ChannelIO) return;
            if (isShow) {
                ChannelIO('showChannelButton');
            } else {
                ChannelIO('hideChannelButton');
            }
        }
    }

    function drawButton() {
        if (Often.isGlobal() ||
            (!Often.isServerModeByHost("REAL") && !Often.isServerModeByHost("REAL_TEST"))
        ) {
            return;
        }

        if (Mutil.isFunc("GPT_TRAINER")) {
            drawGptTrainer();
        } else if (Often.isFunc('HAPPY_TALK')) {
            //connectHappyTalk();
            connectHubspotChatflow();
        }
        //connectChannelTalk();
    }

    function drawGptTrainer(){
        window.GPTTConfig = {uuid: "e7c42ed6979b444683cf2f8876a34c22"};
        const script = document.createElement('script');
        script.src = "https://app.gpt-trainer.com/widget-asset.min.js";
        script.defer = true;
        document.body.appendChild(script);
        script.onload = function() {
            const checkInterval = 300; // 확인 간격(ms)
            const timeoutLimit = 5000; // 최대 대기시간(ms)
            let elapsedTime = 0;
            const interval = setInterval(() => {
                const chatWidget = document.querySelector('chat-widget');
                if (chatWidget && chatWidget.shadowRoot) {
                    const button = chatWidget.shadowRoot.querySelector('#chatbot-widget-window-button');
                    if (button) {
                        // const cssTxt = { right: '30px', bottom: '40px', width: '70px', height: '70px', position: 'fixed' };
                        // Object.assign(button.style, cssTxt);
                        clearInterval(interval);
                    }
                }
                elapsedTime += checkInterval;
                if (elapsedTime >= timeoutLimit) {
                    clearInterval(interval);
                    console.warn('chat-widget을 찾지 못했습니다.');
                }
            }, checkInterval);
        }
    }

    function connectHubspotChatflow() {
        $('head').append(`<script type="text/javascript" id="hs-script-loader" async defer src="//js-na1.hs-scripts.com/24076689.js"></script>`);
    }

    function connectHappyTalk() {
        ((id, scriptSrc, callback) => {
            const d = document, tagName = 'script', $script = d.createElement(tagName),
                $element = d.getElementsByTagName(tagName)[0];
            $script.id = id;
            $script.async = true;
            $script.src = scriptSrc;
            $script.addEventListener('load', callback, false);
            $element.parentNode.insertBefore($script, $element);
        })('happytalkSDK', 'https://design.happytalkio.com/sdk/happytalk.chat.v2.min.js', () => {
            window.ht = new Happytalk({
                siteId: '3000000519',
                siteName: '협업툴 플로우',
                categoryId: '144227',
                divisionId: '153097',
                kakaoId: '@협업툴플로우',
                options: {
                    pcButtonRight: 22, pcButtonBottom: 22, mobileButtonRight: 24, mobileButtonBottom: 24,
                }
            });
            setTimeout(() => {
                const {htButtonLoaded = false, _view = {}} = window.ht;
                const {$iframe = $()} = _view;
                if (!htButtonLoaded) $('body').append($iframe);
            }, 300)
        });
    }

    function connectChannelTalk() {
        (function () {
            var w = window;
            if (w.ChannelIO) return;
            var ch = function () {
                ch.c(arguments);
            };
            ch.q = [];
            ch.c = function (args) {
                ch.q.push(args);
            };
            w.ChannelIO = ch;

            function l() {
                if (w.ChannelIOInitialized) return;
                w.ChannelIOInitialized = true;
                var s = document.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
                s.charset = 'UTF-8';
                var x = document.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            }

            if (document.readyState === 'complete') {
                l();
            } else if (window.attachEvent) {
                window.attachEvent('onload', l);
            } else {
                window.addEventListener('DOMContentLoaded', l, false);
                window.addEventListener('load', l, false);
            }
        })();

        //페이지별 채널록
        let pluginKey = "4daeece0-6838-4a53-9c62-febd9b7bd30e";
        let zIndex = 9;
        let profile = "";

        if (Often.isAct("main")) {
            pluginKey = "36f7d6c1-141c-4f0b-b1b1-d9287bed6aaf";
            zIndex = 0;
            let userData = {};
            if (Ajax.getData("COLABO2_USER_PRFL_R002")) {
                userData = Ajax.getData("COLABO2_USER_PRFL_R002").response;
                return;
            }
            profile = {
                "flow_code": userData.USE_INTT_ID,  // 이용기관코드
                "flow_company": userData.CMNM,   // 회사
                "flow_department": userData.DVSN_NM, // 부서
                "flow_id": userData.USER_ID, // 아이디
                "flow_name": userData.FLNM  // 이름
            };
        }

        ChannelIO('boot', {
            "pluginKey": pluginKey, "locale": "ko", "zIndex": zIndex, "profile": profile,
        });
    }
}()
